// Shows a flash toast built in JS, with the markup of Ui::FlashComponent — the `flash` Stimulus
// controller then animates and closes it. Goes in the Turbo layouts' #flashes frame, or the admin
// Vue layout's [data-is-flash-message] container.
//  - content : html (trusted callers only)
//  - type : flash key or Bootstrap name (notice, success, error, danger, alert, warning, info)

const KIND_VARIANTS = {
  notice: "success",
  success: "success",
  error: "danger",
  danger: "danger",
  alert: "warning",
  warning: "warning",
  info: "info"
}

// Mirrors Ui::FlashComponent::VARIANTS.
const VARIANTS = {
  success: { htmlClass: "flash-message--success", fa: "fa fa-circle-check", ph: "ph ph-check-circle" },
  danger: { htmlClass: "flash-message--danger", fa: "fa fa-circle-exclamation", ph: "ph ph-warning-circle" },
  warning: { htmlClass: "flash-message--warning", fa: "fa fa-triangle-exclamation", ph: "ph ph-warning" },
  info: { htmlClass: "flash-message--info", fa: "fa fa-circle-info", ph: "ph ph-info" }
}

export default class FlashMessage {
  constructor (content, type) {
    this.container = document.getElementById("flashes") || document.querySelector("[data-is-flash-message]")
    if (!this.container) return

    this.container.innerHTML = this.markup(content, VARIANTS[KIND_VARIANTS[type]] || VARIANTS.info, KIND_VARIANTS[type])
  }

  markup (content, variant, variantName) {
    // The admin keeps Font Awesome (`data-icon-set` on <html>); other layouts load Phosphor only.
    const iconSet = document.documentElement.dataset.iconSet === "fa" ? "fa" : "ph"
    const closeIcon = iconSet === "fa" ? "fa fa-xmark" : "ph ph-x"
    const role = ["danger", "warning"].includes(variantName) ? "alert" : "status"

    return `
      <div class="flash-message ${variant.htmlClass}" role="${role}" data-controller="flash"
           data-action="mouseenter->flash#freeze mouseleave->flash#unfreeze focusin->flash#freeze focusout->flash#unfreeze">
        <span class="flash-message__icon" aria-hidden="true"><i class="${variant[iconSet]}"></i></span>
        <p class="flash-message__text">${content}</p>
        <button type="button" class="flash-message__close" aria-label="Fermer la notification" data-action="flash#close">
          <i class="${closeIcon}" aria-hidden="true"></i>
        </button>
        <span class="flash-message__progress"></span>
      </div>
    `
  }
}
